const stores = [
  {
    id: 1616095,
    name: "DC / Corporate Office",
    address: "2120 E 6th St",
    city: "Tempe",
    state: "Arizona",
    zip: "85281",
    phone: "(480) 829-0545",
    lat: 33.4247836,
    lng: -111.895751,
  },
  {
    id: 1616098,
    name: "Arrowhead Towne Center ",
    address: "7700 W Arrowhead Towne Ctr",
    city: "Glendale",
    state: "Arizona",
    zip: "85308 ",
    phone: "(623) 486-2252 ",
    lat: 33.642821,
    lng: -112.22566,
  },
  {
    id: 1616099,
    name: "Superstition Springs",
    address: "6555 East Southern Avenue",
    city: "Mesa",
    state: "Arizona",
    zip: "85206",
    phone: "(480) 396-8824 ",
    lat: 33.3902535,
    lng: -111.6902089,
  },
  {
    id: 1616101,
    name: "Arizona Mills ",
    address: "5000  S Arizona Mills Circle ",
    city: "Tempe",
    state: "Arizona",
    zip: "85282",
    phone: "(480) 345-8900 ",
    lat: 33.384402,
    lng: -111.965153,
  },
  {
    id: 1616103,
    name: "Ontario Mills",
    address: "One Mill Circle",
    city: "Ontario",
    state: "California",
    zip: "91764",
    phone: "(909) 481-6109 ",
    lat: 34.0729843,
    lng: -117.551993,
  },
  {
    id: 1616105,
    name: "Great Mall of the Bay",
    address: "171 Great Mall Drive",
    city: "Milpitas",
    state: "California",
    zip: "95035",
    phone: "(408) 935-9510 ",
    lat: 37.415761,
    lng: -121.897146,
  },
  {
    id: 1616110,
    name: "Scottsdale Fashion Square",
    address: "7014 East Camelback Road",
    city: "Scottsdale",
    state: "Arizona",
    zip: "85251",
    phone: "(480) 946-6775",
    lat: 33.5030835,
    lng: -111.9294525,
  },
  {
    id: 1616111,
    name: "Chandler Fashion Center",
    address: "3111 W. Chandler Blvd.",
    city: "Chandler",
    state: "Arizona",
    zip: "85226",
    phone: "(480) 855-3251",
    lat: 33.3014708,
    lng: -111.8984985,
  },
  {
    id: 1616117,
    name: "Sunvalley Shopping Center",
    address: "175 Sunvalley Shopping Ctr.",
    city: "Concord",
    state: "California",
    zip: "94520",
    phone: "(925) 405-0356",
    lat: 37.9677863,
    lng: -122.0609487,
  },
  {
    id: 1616120,
    name: "Victoria Gardens",
    address: "12582 North Mainstreet",
    city: "Rancho Cucamonga",
    state: "California",
    zip: "91739",
    phone: "(909) 646-7377 ",
    lat: 34.1122303,
    lng: -117.5307948,
  },
  {
    id: 1616125,
    name: "South Plains Mall",
    address: "6002 Slide Road",
    city: "Lubbock",
    state: "Texas",
    zip: "79414",
    phone: "(806) 792-5100 ",
    lat: 33.5392932,
    lng: -101.9253588,
  },
  {
    id: 1616135,
    name: "NoHo New York",
    address: "657 Broadway                                 ",
    city: "New York",
    state: "New York",
    zip: "10012",
    phone: "(212) 260-1313",
    lat: 40.7270537,
    lng: -73.9957003,
  },
  {
    id: 1616137,
    name: "Southcenter Mall",
    address: "2800 Southcenter Mall",
    city: "Tukwila",
    state: "Washington",
    zip: "98188",
    phone: "(206) 466-2019",
    lat: 47.4585492,
    lng: -122.2585718,
  },
  {
    id: 1616140,
    name: "Roosevelt Field",
    address: "630 Old Country Rd             ",
    city: "Garden City   ",
    state: "New York",
    zip: "11530",
    phone: "(516) 882-4058",
    lat: 40.7380631,
    lng: -73.6128077,
  },
  {
    id: 1616141,
    name: "Garden State Plaza",
    address: "1 Garden State Plaza Blvd.",
    city: "Paramus",
    state: "New Jersey",
    zip: "7652",
    phone: "(201) 843-2952",
    lat: 40.9181345,
    lng: -74.0773403,
  },
  {
    id: 1616144,
    name: "Desert Sky",
    address: "7611 W Thomas Rd",
    city: "Phoenix",
    state: "Arizona",
    zip: "85033",
    phone: "(623) 247-1742",
    lat: 33.4769375,
    lng: -112.2249003,
  },
];

export default stores;
